import supabase from '../supabaseClient';

const FN_URL = "https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1";

// ── Llamadas a Edge Functions de super admin ────────────────────
// Siempre envían el access_token real de la sesión: la Edge Function
// revalida ese token y comprueba app_metadata.rol === 'superadmin'
// en el servidor antes de tocar nada (nunca se confía en el frontend).
const callAdminFn = async (nombre, body) => {
  const { data: { session } } = await supabase.auth.getSession();
  const r = await fetch(`${FN_URL}/${nombre}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token}` },
    body: JSON.stringify(body)
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || "Error en la operación.");
  return data;
};

export const sbListarAlmacenes = () => callAdminFn("admin-listar-almacenes", {});
export const sbCrearAlmacen = (payload) => callAdminFn("admin-crear-almacen", payload);
export const sbActualizarModulos = (almacen_id, modulos) => callAdminFn("admin-actualizar-modulos", { almacen_id, modulos });
export const sbActualizarAlmacen = (almacen_id, cambios) => callAdminFn("admin-actualizar-almacen", { almacen_id, ...cambios });
export const sbListarCuentas = () => callAdminFn("admin-listar-cuentas", {});
export const sbActualizarEstadoCuenta = (cuenta_id, accion) => callAdminFn("admin-actualizar-estado-cuenta", { cuenta_id, accion });
